import {APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {MatExpansionModule} from '@angular/material/expansion'; 
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatIconModule} from '@angular/material/icon';
import {MatButtonModule} from '@angular/material/button';
import {LayoutModule} from '@angular/cdk/layout';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatGridListModule} from '@angular/material/grid-list';
import {MatCardModule} from '@angular/material/card';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatListModule} from '@angular/material/list';
import {MatDividerModule} from '@angular/material/divider';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { FlexLayoutModule } from '@angular/flex-layout';
import {MatDialogModule} from '@angular/material/dialog';
import {CdkAccordionModule} from '@angular/cdk/accordion';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatTreeModule} from '@angular/material/tree';
import {MatPaginatorModule} from '@angular/material/paginator';
import {MatTabsModule} from '@angular/material/tabs';
import {MatProgressBarModule} from '@angular/material/progress-bar';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { MatSidenav } from '@angular/material/sidenav';
import {MatMenuModule} from '@angular/material/menu';
import { NgSlimScrollModule, SLIMSCROLL_DEFAULTS } from 'ngx-slimscroll';
import { NgScrollbarModule } from 'ngx-scrollbar';
import {MatTableModule} from '@angular/material/table';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatDatepickerModule} from '@angular/material/datepicker';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {CdkTreeModule} from '@angular/cdk/tree';
import { AngularSplitModule } from "angular-split";
import { SwiperModule } from "swiper/angular";
import {MatSnackBarModule, MAT_SNACK_BAR_DEFAULT_OPTIONS} from '@angular/material/snack-bar';
import {MatButtonToggleModule} from '@angular/material/button-toggle'; 
import {TableModule} from 'primeng/table';
import {ButtonModule} from 'primeng/button';
import { NotifierModule, NotifierOptions } from 'angular-notifier';
import {MatBadgeModule} from '@angular/material/badge';
import { NgPasswordValidatorModule } from 'ng-password-validator';
import { MatPasswordStrengthModule } from '@angular-material-extensions/password-strength';
import {MatChipsModule} from '@angular/material/chips';
import { JoyrideModule } from 'ngx-joyride';



import { LayoutComponent } from './layout/layout.component';
import { MeetingsComponent } from './screens/meetings/meetings.component';
import { TextDisplayComponent } from './components/text-display/text-display.component';
import { UpcomingMeetingComponent } from './components/upcoming-meeting/upcoming-meeting.component';
import { TaskComponent } from './components/task/task.component';
import { PastMeetingsComponent } from './components/past-meetings/past-meetings.component';
import { CalendarComponent } from './screens/calendar/calendar.component';
import { ProjectStatusDialogComponent } from './components/right-side-opener/project-status-dialog.component';
import { PreviousMeetingsComponent } from './components/previous-meetings/previous-meetings.component';
import { ScheduleAndInstantComponent } from './screens/ScheduleAndInstant/schedule-and-instant/schedule-and-instant.component';
import { MeetingDetailsComponent } from './screens/meeting-details/meeting-details.component';
import { TreeComponent } from './components/tree/tree.component';
import { MeetingListComponent } from './components/meeting-list/meeting-list.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { TaskListComponent } from './screens/task-list/task-list.component';
import { TaskListTreeComponent } from './components/task-list-tree/task-list-tree.component';
import { TaskListItemComponent } from './components/task-list-item/task-list-item.component';
import { TaskListDialogComponent } from './components/task-list-dialog/task-list-dialog.component';
import { TaskTitleDialogComponent } from './components/left-side-opener/task-title-dialog.component';
import { PastMeetingsListComponent } from './components/past-meetings-list/past-meetings-list.component';
import { MeetingTitleDialogComponent } from './components/meeting-title-dialog/meeting-title-dialog.component';
import { InstantMeetingDescriptionComponent } from './components/instant-meeting-description/instant-meeting-description.component';
import { InstantParticipantsComponent } from './components/instant-participants/instant-participants.component';
import { InstantMeetingAgendaComponent } from './components/instant-meeting-agenda/instant-meeting-agenda.component';
import { PreviousMeetingHistoryDialogComponent } from './components/previous-meeting-history-dialog/previous-meeting-history-dialog.component';
import { InstantMeetingCreatedComponent } from './screens/instant-meeting-created/instant-meeting-created.component';
import { TimerComponent } from './components/timer/timer.component';
import { InstantPreviousMeetingDialogComponent } from './components/instant-previous-meeting-dialog/instant-previous-meeting-dialog.component';
import { FixedPreviousMeetingComponent } from './screens/fixed-previous-meeting/fixed-previous-meeting.component';
import { SideNavServiceService } from './service/side-nav-service.service';
import { VertMenuComponent } from './components/vert-menu/vert-menu.component';
import { TableDialogComponent } from './components/table-dialog/table-dialog.component';
import {MatNativeDateModule, MatRippleModule} from '@angular/material/core';
import { MatRadioModule } from '@angular/material/radio'
import { NgxMaskModule, IConfig } from 'ngx-mask';
import { AddParticipantPopupComponent } from './components/add-participant-popup/add-participant-popup.component';
import { MoreParticipantMenuComponent } from './components/more-participant-menu/more-participant-menu.component';
import { MoreParticipantPreviousMeetingPopupComponent } from './components/more-participant-previous-meeting-popup/more-participant-previous-meeting-popup.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { Globals } from './service/global';
import { HttpClient,HttpClientModule, HttpHandler, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { CkEditorConfig } from './config/ckeditor-config';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { InstantMeetingNoteComponent } from './components/instant-meeting-note/instant-meeting-note.component';
import { InstantMeetingDecisionComponent } from './components/instant-meeting-decision/instant-meeting-decision.component';
import { InstantMeetingTaskComponent } from './components/instant-meeting-task/instant-meeting-task.component';
import { SafeHtmlPipe } from './pipe/safe-html.pipe';
import { StripHtmlPipe } from './pipe/strip-html.pipe';
import { SafeAgnedaPipe } from './pipe/safe-agneda.pipe';
import { SafeMinutesPipe } from './pipe/safe-minutes.pipe';
import { AttendeeDialogComponent } from './components/attendee-dialog/attendee-dialog.component';
import { OnlyNumberDirective } from './directives/only-number.directive';
import { CreateMeetingComponent } from './screens/create-meeting/create-meeting.component';
import { CreateMeetingNavigatorComponent } from './components/create-meeting-navigator/create-meeting-navigator.component';
import {FocusOnErrorDirective} from 'src/app/directives/focus-on-error.directives'
import { AgendaTitleMoreComponent } from './components/agenda-title-more/agenda-title-more.component';
import { AgendaNotesFieldComponent } from './components/dialog-notes-field/agenda-notes-field.component';
import { PredefinedNotesFieldComponent } from './components/dialog-predefined-notes/predefined-notes-field.component';
import { AgendaTaskEditDialogComponent } from './components/agenda-task-edit-dialog/agenda-task-edit-dialog.component';
import { MinutesOfMeetingComponent } from './screens/minutes-of-meeting/minutes-of-meeting.component';
import { MomTreeComponent } from './components/mom-tree/mom-tree.component';
import { ClickCatcherDirective } from './directives/click-catcher.directive';
import { CentreSmallOpenerComponent } from './components/centre-small-opener/centre-small-opener.component';
import { AttachmentDialogComponent } from './components/attachment-dialog/attachment-dialog.component';
import { ConfidentialDialogComponent } from './components/confidential-dialog/confidential-dialog.component';
import { AgendaEditDialogComponent } from './components/agenda-edit-dialog/agenda-edit-dialog.component';
import { AddLinkDialogComponent } from './components/add-link-dialog/add-link-dialog.component';
import { CdTimerModule } from 'angular-cd-timer';
import { LoginPageComponent } from './screens/login-page/login-page.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { SplitPaneFrameComponent } from './components/split-pane-frame/split-pane-frame.component';
import { GridTableComponent } from './components/grid-table/grid-table.component';
import { SearchPageComponent } from './screens/search-page/search-page.component';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { ComingSoonPageComponent } from './components/coming-soon-page/coming-soon-page.component';
import { SettingsPageComponent } from './screens/settings-page/settings-page.component';
import { ProfilePageComponent } from './screens/profile-page/profile-page.component';
import { PastMeetingDialogComponent } from './components/past-meeting-dialog/past-meeting-dialog.component';
import { TaskSearchGridComponent } from './components/task-search-grid/task-search-grid.component';
import { FooterComponent } from './components/footer/footer.component';
import { NgxSpinnerModule } from 'ngx-spinner';
import { PasswordCreationComponent } from './screens/password-creation/password-creation.component';
import { ShortcutDialogComponent } from './components/shortcut-dialog/shortcut-dialog.component';
import { DeleteMeetingPopupComponent } from './components/delete-meeting-popup/delete-meeting-popup.component';
import { ScheduleMeetingPopupComponent } from './components/schedule-meeting-popup/schedule-meeting-popup.component';
import { ParticReviewSelectDialogComponent } from './components/partic-review-select-dialog/partic-review-select-dialog.component';
import { PreviewMinutesDialogComponent } from './components/preview-minutes-dialog/preview-minutes-dialog.component';
import { FollowupMeetingPopupComponent } from './components/followup-meeting-popup/followup-meeting-popup.component';
import { CopymeetingComponent } from './components/copymeeting/copymeeting.component';
import { CancelMeetingPopupComponent } from './components/cancel-meeting-popup/cancel-meeting-popup.component';
import { NotHeldPopupComponent } from './components/not-held-popup/not-held-popup.component';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { TrackAttendeeDialogComponent } from './components/track-attendee-dialog/track-attendee-dialog.component';
import { ForgotPasswordPageComponent } from './screens/forgot-password-page/forgot-password-page.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { TourDialogComponent } from './components/tour-dialog/tour-dialog.component';
import { GlobalInterceptor } from './service/GlobalInterceptor';
// import { ToastrModule } from 'ngx-toastr';
import { VideoTourComponent } from './components/video-tour/video-tour.component';
import { NotesAttachementDialogComponent } from './components/notes-attachement-dialog/notes-attachement-dialog.component';
import { ShortNamePipe } from './pipe/short-name.pipe';
import { InstantMeetingFollowupTaskComponent } from './components/instant-meeting-followup-task/instant-meeting-followup-task.component';
//import { CKEditorModule } from 'ckeditor4-angular';
import { MatSortModule } from '@angular/material/sort';
import { SaveTemplateDialogComponent } from './components/save-template-dialog/save-template-dialog.component';
import { ParticipantViewChipComponent } from './components/participant-view-chip/participant-view-chip.component';
import { TemplatePreviewDialogComponent } from './components/template-preview-dialog/template-preview-dialog.component';
import { CreateMeetingTemplateViewComponent } from './screens/create-meeting-template-view/create-meeting-template-view.component';
// import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';  // this includes the core NgIdleModule but includes keepalive providers for easy wireup
import { ActivateUserViewComponent } from './screens/activate-user-view/activate-user-view.component';
import { ViewMomDialogComponent } from './components/view-mom-dialog/view-mom-dialog.component';
import { IsGrantedDirective } from './directives/permission.directive';
import { VideoBoxComponent } from './components/video-box/video-box.component';
import { ApprovedMeetingPageComponent } from './screens/approved-meeting-page/approved-meeting-page.component';
import { ErrorPageComponent } from './screens/error-page/error-page.component';
import { PreviousAgendaDialogComponent } from './components/previous-agenda-dialog/previous-agenda-dialog.component';
import { CommonSearchFieldComponent } from './components/common-search-field/common-search-field.component';
import { CommonButtonTogglerComponent } from './components/common-button-toggler/common-button-toggler.component';
import { MeetingTimerComponent } from './components/meeting-timer/meeting-timer.component';
import { JwtInterceptor } from './service/jwt.interceptor';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { CommonCountPortletComponent } from './components/common-count-portlet/common-count-portlet.component';
import { DropdownMenuTabViewComponent } from './components/dropdown-menu-tab-view/dropdown-menu-tab-view.component';
import { HelpVideoViewComponent } from './screens/help-video-view/help-video-view.component';
import { HtmlVideoTagComponent } from './components/html-video-tag/html-video-tag.component';
import { TuleapDialogComponent } from './components/tuleap-dialog/tuleap-dialog.component';
import { DragDialogComponent } from './components/drag-dialog/drag-dialog.component';

// import { ZoomOAuthComponent } from './components/zoom-oauth/zoom-oauth.component';
//import { SpeechRecognitionComponent } from './components/speech-recognition/speech-recognition.component';
import { ReportComponent } from './components/report/report.component';
import { SessionIdleComponent } from './session-idle/session-idle.component';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { PhemeComponent } from './components/pheme/pheme.component';
import { PhemeReportsComponent } from './components/pheme-reports/pheme-reports.component';
import { UtcDatePipe } from './pipe/UtcDate.pipe';
import { HistoryComponent } from './components/history/history.component';
import { DropdownComponent } from './components/dropdown/dropdown.component';
import { DocumentMeetingComponent } from './components/document-meeting/document-meeting.component';
import { SendMessageDialogComponent } from './components/send-message-dialog/send-message-dialog.component';
import { HelpVideoWebComponent } from './screens/help-video-web/help-video-web.component';
// import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';
import { PreviewAttachmentComponent } from './components/preview-attachment/preview-attachment.component';
import { GrapesjsEditorComponent } from './components/grapesjs-editor/grapesjs-editor.component';
import { LinkNotetotaskDialogComponent } from './components/link-notetotask-dialog/link-notetotask-dialog.component';
import { TemplateDialogComponent } from './components/template-dialog/template-dialog.component';
import { GrapesJsPopupComponent } from './components/grapes-js-popup/grapes-js-popup.component';
import { ZoomOAuthComponent } from './components/zoom-oauth/zoom-oauth.component';
import { AgoraConfigService } from 'src/AgoraConfigService';
import { APP_BASE_HREF } from '@angular/common';
import { AdvanceSearchComponent } from './components/advance-search/advance-search.component';
import { PreviewShareAgendaComponent } from './components/preview-share-agenda/preview-share-agenda.component';
import { ProteanFormsComponent } from './components/protean-forms/protean-forms.component';
import { AdcComponentsModule } from 'dist/adc-lib';
import { DrillDownPreviewComponent } from './components/drill-down-preview/drill-down-preview.component';
import { GridDashboardComponent } from './components/grid-dashboard/grid-dashboard.component';
import { AdcChipComponent } from './components/adc-chip/adc-chip.component';
import { NgxEchartsModule } from 'ngx-echarts';
import * as echarts from 'echarts';
import { KtdGridModule } from '@katoid/angular-grid-layout';
import { StatusConversionPipe } from './pipe/status-conversion.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { TeamsSyncPageComponent } from './screens/teams-sync-page/teams-sync-page.component';
import { TeamsSyncResultsDialogComponent } from './components/teams-sync-results-dialog/teams-sync-results-dialog.component';
import { QuillModule } from 'ngx-quill';
import { AdcEditorComponent } from './components/adc-editor/adc-editor/adc-editor.component';

const customNotifierOptions: NotifierOptions = {
  position: {
		horizontal: {
			position: 'right',
			distance: 12
		},
		vertical: {
			position: 'bottom',
			distance: 60,
			gap: 10
		}
	},
  theme: 'material',
  behaviour: {
    autoHide: 6000,
    onClick: 'hide',
    onMouseover: 'pauseAutoHide',
    showDismissButton: true,
    stacking: 4
  },
  animations: {
    enabled: true,
    show: {
      preset: 'slide',
      speed: 300,
      easing: 'ease'
    },
    hide: {
      preset: 'fade',
      speed: 300,
      easing: 'ease',
      offset: 50
    },
    shift: {
      speed: 300,
      easing: 'ease'
    },
    overlap: 150
  }
};

@NgModule({ declarations: [
        AppComponent,
        DashboardComponent,
        LayoutComponent,
        OnlyNumberDirective,
        FocusOnErrorDirective,
        MeetingsComponent,
        TextDisplayComponent,
        UpcomingMeetingComponent,
        TaskComponent,
        PastMeetingsComponent,
        CalendarComponent,
        ProjectStatusDialogComponent,
        PreviousMeetingsComponent,
        ScheduleAndInstantComponent,
        MeetingDetailsComponent,
        TreeComponent,
        MeetingListComponent,
        PaginationComponent,
        TaskListComponent,
        TaskListTreeComponent,
        TaskListItemComponent,
        TaskListDialogComponent,
        TaskTitleDialogComponent,
        PastMeetingsListComponent,
        MeetingTitleDialogComponent,
        InstantMeetingDescriptionComponent,
        InstantParticipantsComponent,
        InstantMeetingAgendaComponent,
        PreviousMeetingHistoryDialogComponent,
        InstantMeetingCreatedComponent,
        TimerComponent,
        InstantPreviousMeetingDialogComponent,
        FixedPreviousMeetingComponent,
        VertMenuComponent,
        TableDialogComponent,
        AddParticipantPopupComponent,
        MoreParticipantMenuComponent,
        MoreParticipantPreviousMeetingPopupComponent,
        InstantMeetingNoteComponent,
        InstantMeetingDecisionComponent, InstantMeetingFollowupTaskComponent,
        InstantMeetingTaskComponent, SafeHtmlPipe, SafeAgnedaPipe, SafeMinutesPipe, ShortNamePipe, UtcDatePipe, StatusConversionPipe, StripHtmlPipe,
        AttendeeDialogComponent,
        CreateMeetingComponent,
        CreateMeetingNavigatorComponent,
        AgendaTitleMoreComponent,
        AgendaNotesFieldComponent,
        PredefinedNotesFieldComponent,
        AgendaTaskEditDialogComponent,
        MinutesOfMeetingComponent,
        MomTreeComponent,
        ClickCatcherDirective,
        CentreSmallOpenerComponent,
        AttachmentDialogComponent,
        ConfidentialDialogComponent,
        AgendaEditDialogComponent,
        AddLinkDialogComponent,
        LoginPageComponent,
        ConfirmDialogComponent,
        SplitPaneFrameComponent,
        GridTableComponent,
        SearchPageComponent,
        LoginPageComponent,
        ComingSoonPageComponent,
        SettingsPageComponent,
        ProfilePageComponent,
        PastMeetingDialogComponent,
        TaskSearchGridComponent,
        FooterComponent,
        PasswordCreationComponent,
        ShortcutDialogComponent,
        DeleteMeetingPopupComponent,
        ShortcutDialogComponent,
        ScheduleMeetingPopupComponent,
        CopymeetingComponent,
        FollowupMeetingPopupComponent,
        ParticReviewSelectDialogComponent,
        ScheduleMeetingPopupComponent,
        PreviewMinutesDialogComponent,
        ViewMomDialogComponent,
        CancelMeetingPopupComponent,
        NotHeldPopupComponent,
        TrackAttendeeDialogComponent,
        ForgotPasswordPageComponent,
        TourDialogComponent,
        VideoTourComponent,
        NotesAttachementDialogComponent,
        SaveTemplateDialogComponent,
        ParticipantViewChipComponent,
        TemplatePreviewDialogComponent,
        CreateMeetingTemplateViewComponent,
        ActivateUserViewComponent,
        IsGrantedDirective,
        ActivateUserViewComponent,
        VideoBoxComponent,
        ApprovedMeetingPageComponent,
        ErrorPageComponent,
        PreviousAgendaDialogComponent,
        CommonSearchFieldComponent,
        CommonButtonTogglerComponent,
        MeetingTimerComponent,
        CommonCountPortletComponent,
        DropdownMenuTabViewComponent,
        HelpVideoViewComponent,
        HtmlVideoTagComponent,
        TuleapDialogComponent,
        DragDialogComponent,
        ZoomOAuthComponent,
        //SpeechRecognitionComponent,
        ReportComponent,
        SessionIdleComponent,
        PhemeComponent,
        PhemeReportsComponent,
        DropdownComponent,
        HistoryComponent,
        DropdownComponent,
        DocumentMeetingComponent,
        SendMessageDialogComponent,
        HelpVideoWebComponent,
        PreviewAttachmentComponent,
        GrapesjsEditorComponent,
        GrapesJsPopupComponent,
    TemplateDialogComponent,
    LinkNotetotaskDialogComponent,
    AdvanceSearchComponent,
    PreviewShareAgendaComponent,
    ProteanFormsComponent,
    DrillDownPreviewComponent,
    GridDashboardComponent,
    AdcChipComponent,
    TeamsSyncPageComponent,
    TeamsSyncResultsDialogComponent
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
     imports: [
        MatFormFieldModule,
        MatInputModule,
        MatExpansionModule,
        MatSelectModule,
        MatButtonModule,
        BrowserModule,
        AppRoutingModule,
        BrowserAnimationsModule,
        LayoutModule,
        MatToolbarModule,
        NgxMaskModule.forRoot(),
        MatIconModule,
        // MatButtonModule,
        MatSidenavModule,
        MatGridListModule,
        MatCardModule,
        // MatFormFieldModule,
        MatListModule,
        MatDividerModule,
        MatCheckboxModule,
        MatRadioModule,
        FlexLayoutModule,
        MatDialogModule,
        CdkAccordionModule,
        MatSlideToggleModule,
        MatTreeModule,
        MatPaginatorModule,
        MatTabsModule,
        MatProgressBarModule,
        // MatSelectModule,
        // MatInputModule,
        DragDropModule,
        NgSlimScrollModule,
        NgScrollbarModule,
        MatMenuModule,
        MatTableModule,
        MatTooltipModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRippleModule,
        MatAutocompleteModule,
        FormsModule,
        ReactiveFormsModule,
        CdkTreeModule,
        AngularSplitModule,
        SwiperModule,
        MatSortModule,
        CdTimerModule,
        MatSnackBarModule,
        MatButtonToggleModule,
        TableModule,
        ButtonModule,
        NotifierModule.withConfig(customNotifierOptions),
        MatProgressSpinnerModule,
        MatBadgeModule,
        NgxSpinnerModule,
        AdcEditorComponent,
        // NgPasswordValidatorModule,
        // MatPasswordStrengthModule.forRoot(),
        MatChipsModule,
        NgxMatSelectSearchModule,
        AdcComponentsModule,
        TimepickerModule.forRoot(),
        PopoverModule.forRoot(),
        JoyrideModule.forRoot(),
        TooltipModule.forRoot(),
        // ToastrModule.forRoot({timeOut:10000,positionClass:"toast-bottom-left"}),
        CKEditorModule,
        // MatExpansionModule,
        CarouselModule.forRoot(),
        //ContextMenuModule.forRoot(),
        NgxEchartsModule,
        NgxEchartsModule.forRoot({
         echarts,
        }),
        KtdGridModule,
        NgIdleKeepaliveModule.forRoot(),
        TranslateModule.forRoot(),
        QuillModule.forRoot(),
        // Standalone common Quill editor wrapper
        ModalModule.forRoot()], providers: [{provide:'nonce',useValue:'{{CSP_NONCE}}'},{
            provide: SLIMSCROLL_DEFAULTS,
            useValue: {
                alwaysVisible: false,
                gridOpacity: '0.2', barOpacity: '0.5',
                gridBackground: '#fff',
                gridWidth: '6',
                gridMargin: '2px 2px',
                barBackground: '#fff',
                barWidth: '20',
                barMargin: '2px 2px'
            },
        }, SideNavServiceService, Globals, CkEditorConfig,
        {
          provide: APP_INITIALIZER,
          useFactory: initializeApp,
          multi: true,
          deps: [AgoraConfigService]
        },
        { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
        { provide: HTTP_INTERCEPTORS, useClass: GlobalInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        {
          provide: APP_BASE_HREF,
          useFactory: baseUrlFactory,
          deps: [AgoraConfigService]
        },
         provideHttpClient(withInterceptorsFromDi()),] })
export class AppModule { }
export function initializeApp(configurationService: AgoraConfigService) {
  return () => configurationService.setEnvironmentConfig();
 
}
export function baseUrlFactory(configService: AgoraConfigService): string {
  const config = configService.getConfig();
  return config?.endpoints?.contextPath || ''; // Provide default if undefined
}
